<template>
  <div class="apply">
    <div class="apply-icon">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
	<div class="apply-logo">
		<img src="https://image.ceekee.com/h5/logo23.png" alt="" />
	</div>
    <div class="appointright">
      <p>差旅管家Tripwise体验申请</p>
      <div class="inputLi">
        <el-input v-model="name" placeholder="姓名"></el-input>
      </div>
      <div class="inputLi">
        <el-input v-model="phone" placeholder="手机号"></el-input>
      </div>
      <div class="inputLi imgCode">
        <el-input v-model="imgCode" placeholder="图形验证码"></el-input>
        <p><img @click="changeCode" :src="imgCodeUrl" /></p>
      </div>
      <div class="inputLi code">
        <el-input v-model="smsCode" placeholder="短信验证码"></el-input>
        <p v-if="!count" @click="getSendCode">获取验证码</p>
        <p v-else>{{ count }}s</p>
      </div>
      <div class="check-box">
		  <el-checkbox v-model="checked"></el-checkbox>
		  <p>同意<span>《差旅管家Tripwise服务使用协议》</span></p>
      </div>
      <div class="footer-box">
        <el-button type="primary" native-type="submit" @click="submits"
          >提交</el-button
        >
      </div>
	  <div class="footer-warning">*我们将在1个工作日内与您联系</div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'apply',
	data() {
		return {
			name: '',
			phone: '',
			imgCode: '',
			smsCode: '',
			checked: false,
			dialogVisible: false,
			validateCode:'',
			imgCodeUrl:'',
			timer: null,
			count:0,
		};
	},
	mounted() {
		this.changeCode();	
	},
	methods: {
		//获取验证码
		changeCode(){
			var timestamp = new Date().getTime();//时间戳
			this.validateCode=timestamp;
			this.imgCodeUrl = 'https://api.ceekeeapi.com/b2b/File/SecurityCode?v='+timestamp+'&s=4';
		},
		//发送验证码
		getSendCode(){
			if(!this.checkInput()) return;
			if(!this.imgCode){
				this.$commonFun.toast('请先获取并输入图形验证码');
				return ;
			}
			this.$api.sendSms({
				PlatId: "1003",
				Validate: this.imgCode,
				ValidateCode: this.validateCode,//时间戳
				Version: "5.0.3",
				phone: this.phone,
				sendtype: 7
			}).then((res) => {
				//短信发送成功
				this.$notify({
					title: '发送成功',
					message: '短信发送成功，请注意查收',
					type: 'success'
				});
				this.getCode();
			});
		},
		//预约表单信息提交
		submits() {
			this.$alert('<p>提交成功，1个工作日内会有专属顾问联系您。</p>', '体验提醒',{
				customClass: 'setAlert',
				dangerouslyUseHTMLString: true
			});
			if(!this.name){
				this.$commonFun.toast('请输入您的姓名');
				return ;
			}
			if(!this.checkInput()) return;
			if(!this.smsCode){
				this.$commonFun.toast('请输入短信验证码');
				return ;
			}
			if(!this.checked){
				this.$commonFun.toast('请同意并阅读差旅管家TripWise服务使用协议');
				return ;
			}
			this.$api.experience({
				PlatId: "1002",
				ContactsName: this.name,
				ContactsPhone: this.phone,
				SMSCode:this.smsCode,
				Version: "5.0.8",
			}).then((res) => {
				//申请成功
				this.$alert('提交成功，1个工作日内会有专属顾问联系您。', '体验提醒');
				setTimeout(()=>{
					this.$router.push({ path: "/" })
				},1500)
			});
		},
		//验证码倒计时
		getCode(){
		    const TIME_COUNT = 60;
			this.count=TIME_COUNT;
			this.timer = setInterval(() => {
				if (this.count > 0) {
					this.count--;
				} else {
					clearInterval(this.timer);
					this.timer = null;
				}
			}, 1000)
		},
		checkInput(){
			if(!this.phone){
				this.$commonFun.toast('请输入手机号');
				return false;
			}
			if(this.phone.length !== 11){
				this.$commonFun.toast('请输入正确的手机号码');
				return false;
			}
			return true;
		},
	},
};
</script>

<style scoped lang="less">
.apply {
  padding-top: 164px;
  background-color: #1b2f4a;
  position: relative;
  overflow: hidden;
  height: 100vh;
  .apply-icon {
    position: absolute;
    top: 46px;
    left: 60px;
	img {
		height: 86px;
	}
  }
  .apply-logo {
	position: absolute;
    top: 0;
    right: 0;
	transform: translate(10%,-30%);
	img {
		height: 362px;
	}
  }
}
.appointright {
  margin: 0 auto;
  width: 90%;
  box-sizing: border-box;
  padding: 30px 70px;
  background: #fff;
  border-radius: 18px;
  & > p {
    font-size: 32px;
    font-weight: 600;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 40px;
  }
  button {
    width: 200px;
    line-height: 25px;
    font-size: 20px;
  }
  .inputLi {
    height: 80px;
    background: #f8f8f8;
    margin-bottom: 20px;
    line-height: 40px;
    color: rgba(136, 136, 136, 0.85);

    /deep/ .el-input {
      height: 100%;
    }
    /deep/ .el-input__inner {
      height: 100%;
      background-color: #f8f8f8;
      font-size: 27px;
      padding: 0 24px;
    }
  }
  .imgCode {
	position: relative;
	p {
		position: absolute;
		height: 56px;
		width: 116px;
		right: 12px;
		top: 12px;
	}
	img {
		width: 100%;
		height: 100%;
	}
  }
  .code {
    position: relative;
    p {
      height: 60px;
    //   width: 140px;
      color: #fff;
      background: #409eff;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 4px;
      font-size: 18px;
      line-height: 60px;
      text-align: center;
	  padding: 0 10px;
    }
  }
  .check-box {
	  display: flex;
	  align-items: center;
	  margin: 20px 0 40px;
	  font-size: 24px;
	  >p {
		  margin-left: 20px;
		  display: flex;
		  span {
			  color: #0B7AFEFF;
		  }
	  }
	  /deep/ .el-checkbox__inner {
		  height: 30px;
		  width: 30px;
	  }
	  /deep/ .el-checkbox__inner::after {
		  height: 18px;
		  width: 14px;
		  border: 1Px solid #fff;
		  border-top: 0;
		  border-left: 0;
		  left: 20%;
	  }
  }
  .footer-box {
	  button {
		  width: 100%;
		  height: 98px;
		  font-size: 36px;
	  }
  }
  .footer-warning {
	  text-align: center;
	  font-size: 24px;
	  color: #a0a0a0;
	  margin-top: 30px;
  }
}
</style>
<style lang="less">
.setAlert {
	width: 80%;
	span {
		display: inline-block;
		font-size: 30px;
		margin: 10px 0;
	}
	p {
		font-size: 26px;
		margin-bottom: 10px;
	}
	i {
		font-size: 30px;
	}
	button {
		span {
			font-size: 26px;
			margin: 0;
		}
	}
}
</style>